import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-vid-question-radiobutton',
  templateUrl: './vid-question-radiobutton.component.html',
  styleUrls: ['./vid-question-radiobutton.component.scss']
})
export class VidQuestionRadiobuttonComponent implements OnInit {

  @Input() data: any;
  @Input() disable = false;
  @Input() error = false;
  constructor() {
    this.disable = false;
    this.error = false;
  }

  ngOnInit() {
  }

  changeSelection(i) {
    this.data.selectedchoice = i;
    this.error = false;
  }
}
